export const PRIMARY_SITE_HOST = 'www.shipsmartsolution.com';
export const PRIMARY_SITE_URL = `https://${PRIMARY_SITE_HOST}`;

export const LEGACY_SITE_HOSTS = new Set([
  'ship-solutions.net',
  'www.ship-solutions.net',
]);

const LEGACY_FLAT_ROUTE_MAP: Record<string, string> = {
  'managed-transportation': 'shippers/managed-transportation',
  'freight-brokerage': 'shippers/freight-brokerage',
  warehousing: 'shippers/warehousing',
  'dedicated-capacity': 'shippers/dedicated-capacity',
  'capacity-solutions': 'shippers/capacity-solutions',
  'project-logistics': 'shippers/project-logistics',
  'international-logistics': 'shippers/international-logistics',
  'expedited-freight': 'services/expedited',
  'become-a-carrier': 'carriers/become-a-carrier',
  'available-loads': 'carriers/available-loads',
  'carrier-setup-packet': 'carriers/carrier-setup-packet',
  'insurance-requirements': 'carriers/insurance-requirements',
  'carrier-benefits': 'carriers/carrier-benefits',
  'dry-van': 'services/dry-van',
  flatbed: 'services/flatbed',
  reefer: 'services/reefer',
  'heavy-haul': 'services/heavy-haul',
  drayage: 'services/drayage',
  expedited: 'services/expedited',
  'full-truckload': 'services/full-truckload',
  'less-than-truckload': 'services/less-than-truckload',
  'partial-truckload': 'services/partial-truckload',
  intermodal: 'services/intermodal',
  'last-mile-delivery': 'services/last-mile-delivery',
  'sustainable-green-logistics': 'services/sustainable-green-logistics',
  about: 'company/about',
  'carrier-network': 'company/carrier-network',
  'case-studies': 'company/case-studies',
  locations: 'company/locations',
  'real-time-tracking': 'company/real-time-tracking',
  'shipment-visibility': 'company/shipment-visibility',
  'digital-freight-management': 'company/digital-freight-management',
  news: 'company/news',
  guides: 'company/guides',
  faq: 'company/faq',
};

/** Maps known legacy flat URLs page-to-page and preserves already structured paths. */
export function getLegacyMigrationPath(pathname: string) {
  const trimmedPath = pathname.replace(/^\/+|\/+$/g, '');

  if (['robots.txt', 'sitemap.xml', 'llms.txt'].includes(trimmedPath)) {
    return `/${trimmedPath}`;
  }

  const segments = trimmedPath ? trimmedPath.split('/') : [];

  if (['en', 'ru', 'uz'].includes(segments[0]?.toLowerCase())) {
    segments.shift();
  }

  const pathWithoutLocale = segments.join('/');
  if (!pathWithoutLocale) return '/en';

  const mappedPath =
    LEGACY_FLAT_ROUTE_MAP[pathWithoutLocale] ?? pathWithoutLocale;

  return `/en/${mappedPath}`;
}
